import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const LinkSmall: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.92871 10.0716L10.0716 5.92871"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.89366 6.92773L2.34009 8.48131C0.910073 9.91133 0.910073 12.2299 2.34009 13.6599C3.77012 15.0899 6.08864 15.0899 7.51867 13.6599L9.07224 12.1063"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.1054 9.07272L13.6589 7.51915C15.089 6.08913 15.089 3.77061 13.6589 2.34058C12.2288 0.910561 9.91035 0.910563 8.48032 2.34058L6.92676 3.89415"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
